<template>
  <div id="header">
    <header class="header">
      <a href="/" class="logo"><img src="../assets/logo-small.png" width="35" height="35" /></a>
      <input class="menu-btn" type="checkbox" id="menu-btn" />
      <label class="menu-icon" for="menu-btn"><span class="navicon"></span></label>
      <ul class="menu">
        <li>
          <router-link class="spacing link" to="/tables">SALA TORNEI</router-link>
        </li>
        <li>
          <router-link class="spacing link" to="/room">TAVOLO</router-link>
        </li>
        <li>
          <router-link class="spacing link" to="/rules">REGOLAMENTO</router-link>
        </li>
        <li class="footer-link">
          <router-link class="spacing link" to="/privacy">INFORMATIVA PRIVACY</router-link>
        </li>
        <li class="footer-link">
          <router-link class="spacing link" to="/contact-us">CONTATTACI</router-link>
        </li>
      </ul>
       <ul class="menu menu-user">
          <li>
            <a class="spacing no-link" v-if="username">Nickname: {{ username }}</a>
          </li>
       </ul>
    </header>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Header",
  computed: {
    ...mapGetters({ username: "user/username", user: "user/user" })
  },
  methods: {
    logout() {
      const userData = {
        userId: this.user.id
      };
      this.$store.dispatch("user/deleteUser", userData);
    }
  }
};
</script>
<style scoped>
@import "../assets/css/app.css";
header {
  min-height: 50PX;
  padding: 3px;
  text-align: center;
  background: whitesmoke;
  color: darkslategrey;
  font-size: 16px;
  font-weight: 800;
  border-bottom: solid 3px darkslategrey;
  width: 100%;
  position: fixed;
}
a:link,
a:visited {
  color: darkslategrey;
}

a:hover,
a:active {
  color: red;
}
.no-link:hover {
  color: darkslategrey;
}
.footer-link {
  visibility: visible;
}

/* header */

.header {
  background-color: #fff;
  box-shadow: 1px 1px 4px 0 rgba(0,0,0,.1);
  position: fixed;
  width: 100%;
  z-index: 3;
}

.header ul {
  margin: 0;
  padding: 0;
  list-style: none;
  overflow: hidden;
  background-color: #fff;
}

.header li a {
  display: block;
  padding: 8px 8px;
  border-right: 1px solid #f4f4f4;
  text-decoration: none;
}

.header li a:hover,
.header .menu-btn:hover {
  background-color: #f4f4f4;
}

.header .logo {
  display: block;
  float: left;
  font-size: 1.1em;
  padding: 0px 8px;
  text-decoration: none;
  max-width: 150px;
}

/* menu */

.header .menu {
  clear: both;
  max-height: 0;
  transition: max-height .2s ease-out;
}

/* menu icon */

.header .menu-icon {
  cursor: pointer;
  display: inline-block;
  float: right;
  padding: 19px 20px;
  position: relative;
  user-select: none;
}

.header .menu-icon .navicon {
  background: #333;
  display: block;
  height: 2px;
  position: relative;
  transition: background .2s ease-out;
  width: 18px;
}

.header .menu-icon .navicon:before,
.header .menu-icon .navicon:after {
  background: #333;
  content: '';
  display: block;
  height: 100%;
  position: absolute;
  transition: all .2s ease-out;
  width: 100%;
}

.header .menu-icon .navicon:before {
  top: 5px;
}

.header .menu-icon .navicon:after {
  top: -5px;
}

/* menu btn */

.header .menu-btn {
  display: none;
}

.header .menu-btn:checked ~ .menu {
  max-height: 290px;
}

.header .menu-btn:checked ~ .menu-icon .navicon {
  background: transparent;
}

.header .menu-btn:checked ~ .menu-icon .navicon:before {
  transform: rotate(-45deg);
}

.header .menu-btn:checked ~ .menu-icon .navicon:after {
  transform: rotate(45deg);
}

.header .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:before,
.header .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:after {
  top: 0;
}

/* 48em = 768px */

@media (min-width: 53em) {
  .header li {
    float: left;
  }
  .header li a {
    padding: 3px 12px;
  }
  .header .menu {
    clear: none;
    float: left;
    max-height: none;
  }
  .menu-user {
    float: right !important;
  }
  .header .menu-icon {
    display: none;
  }
  .footer-link {
    visibility: hidden;
    width: 0;
    height: 0;
  }
}

</style>
